<template>
  <div :Key="fileKey">
    <label class="d-block">
        <span>{{ custom_value.field_name }}</span>
        <span v-if="isImageFileType(custom_value.value)" style="color: #8b0505;position: absolute;top: 30px;z-index: 10;left: 140px;" title="remove image" @click.prevent="deleteFile">
            <app-icon
            :name="'x'"
            v-popover:tooltip.top="$t('Clear')"
            style="cursor: pointer"></app-icon>
        </span>
    </label>
    <div class="">
      <app-overlay-loader v-if="filePreloader" />

      <app-input
        :id="'file_' + custom_value.id"
        type="custom-file-upload"
        :label="$t('upload_your_file')"
        v-model="custom_value.hhh"
        :customvalue="custom_value.value"
        @change="(e) => saveFile(e.target.files[0], custom_value)"
      />
      <small class="text-muted font-italic">
        {{ $t("recommended_custom_file_validation") }}
      </small>
    </div>
  </div>
</template>

<script>
import coreLibrary from "../../../../../core/helpers/CoreLibrary";
export default {
  name: "GhlstackFile",

  props: {
    custom_value: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      filePreloader: false,
      fileKey: 'key1'
    };
  },

  mounted() {},

  methods: {
    isImageFileType(url) {
      var imageExtensions = /\.(jpeg|jpg|png|svg|webp)$/i;
      // var videoExtensions = /\.(mp4|avi|mov|wmv)$/i;
      if (!url) {
        return false;
      }
      if (url.match(imageExtensions)) {
        return true;
      }
      return false;
    },

    saveFile(file, custom) {
      this.filePreloader = true;
      this.$parent.filePreloader = true;
      let data = new FormData();
      data.append("file", file);
      data.append("custom_id", custom.id);
      coreLibrary.methods
        .axiosPost({
          url: "/file/upload",
          data,
        })
        .then(({ data }) => {
          custom.value = data;
          custom.hhh = data;
        })
        .catch(({ response }) => {
          if (response.data && response.data.message) {
            this.$toastr.e(response.data.message);
            const errors = Object.values(response.data.data).map((el) => el[0]);
            this.$toastr.e(errors);
          }
        })
        .finally(() => {
          this.filePreloader = false;
          this.$parent.filePreloader = false;
        });
    },

    deleteFile() {
      let path = new URL(this.custom_value.value).pathname;
      let data = new FormData();
      data.append("path", path);
      this.filePreloader = true;
      this.$parent.filePreloader = true;
      coreLibrary.methods
        .axiosPost({
          url: "/file/delete",
          data,
        })
        .then(({ data }) => {
            this.custom_value.value = "";
            this.custom_value.hhh = "";
            if(this.fileKey=="key1") this.fileKey="key2";
            else this.fileKey="key1";
        })
        .catch(({ response }) => {
          if (response.data && response.data.message) {
            this.$toastr.e(response.data.message);
            const errors = Object.values(response.data.data).map((el) => el[0]);
            this.$toastr.e(errors);
          }
        })
        .finally(() => {
          this.filePreloader = false;
          this.$parent.filePreloader = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
